import { render, staticRenderFns } from "./StandardDashboard.vue?vue&type=template&id=a9ab90d4&"
import script from "./StandardDashboard.vue?vue&type=script&lang=js&"
export * from "./StandardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StandardDashboard.vue?vue&type=style&index=0&id=a9ab90d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports